import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { FaExclamationCircle, FaCheckCircle, FaTasks, FaExclamationTriangle } from 'react-icons/fa'; // Example icons
import cx from 'classnames';
import { Link } from 'react-router-dom';
import {
  Row,
  Col,
  Button,
  ButtonGroup,
  Breadcrumb,
  BreadcrumbItem,
  Progress,
  Badge,
  Table,
  Alert
} from 'reactstrap';
import {  useNavigate } from 'react-router-dom';

import Widget from '../../components/Widget/Widget';
import LineChart from '../../components/charts/charts/LineChart';
import BarChart from '../../components/charts/charts/BarChart';
import PieChart from '../../components/charts/charts/PieChart';
import './Dashboard.css';
import { getComplianceDashboard, getComplianceForEachStandardDashboard, getUsersTasksDashboard } from '../../services/dashboards'; // Import the API call
import { useTranslation } from 'react-i18next';
import LoadingScreen from 'src/Loading/LoadingScreen';
import { RiProgress2Line } from 'react-icons/ri';
import ResultAssessment from './resultAssessment';
interface Post {
  id: number;
  title: string;
  updatedAt: string;
}

interface DashboardProps {
  posts: Post[];
  isFetching: boolean;
}





function Dashboard() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [isDropdownOpened, setIsDropdownOpened] = useState(false);
  const [dashboardData, setDashboardData] = useState<any>(null);
  const [complianceStatus, setComplianceStatus] = useState<any>([]);
  const [monthlyTasks, setMonthlyTasks] = useState<any>([]);
  const [complianceForEachStandard, setComplianceForEachStandard] = useState<any>([]);
  const [usersTasksDashboard, setUsersTasksDashboard] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(true);


  const fetchDashboardData = async () => {
    setIsLoading(true);
    try {
      const data = await getComplianceDashboard();
      
      if (data.success) {
        setDashboardData(data.data);
        setComplianceStatus([{
          'Compliance': data?.data?.compliance,
          'Partial': data?.data?.partially,
          'NotCompliant': data?.data?.non_compliance,
          'Null': data?.data?.nullCompliance + data?.data?.not_started
        }])
      
        const monthlyTasksWithMonthNames = data.data.monthlyTasks.map((task: any, index: number) => {
          const monthNames = [t("Jan"), t("Feb"), t("Mar"), t("Apr"), t("May"), t("Jun"), t("Jul"), t("Aug"), t("Sep"), t("Oct"), t("Nov"), t("Dec")];
          return { name: monthNames[index], noTasks: task };
        });
       
        setMonthlyTasks(monthlyTasksWithMonthNames);
        
      } else {
        setDashboardData(null);
      }
      
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const fetchComplianceForEachStandardDashboard = async () => {
    try {
      const data = await getComplianceForEachStandardDashboard();
      if (data.success) {
        const formattedData = data.data ? Object.keys(data.data).map((key: string) => ({
          id: key,
          reference_name: data.data[key].reference_name,
          compliant: data.data[key].compliance,
          nonCompliant: data.data[key].non_compliance,
          partial: data.data[key].partially
        })) : [];
        
        setComplianceForEachStandard(formattedData);
      }
      
    } catch (error) {
      console.error("Error fetching compliance for each standard dashboard:", error);
    }
  }

  const fetchUsersTasksDashboard = async () => {
    try {
      const data = await getUsersTasksDashboard();
      if (data.success) {
        setUsersTasksDashboard(data.data);
      }
      console.log(data);
    } catch (error) {
      console.error("Error fetching users tasks dashboard:", error);
    }
  }

  useEffect(() => {
    fetchDashboardData();
    fetchComplianceForEachStandardDashboard();
    fetchUsersTasksDashboard();
   
   
  }, []);

  const formatDate = (str: string) => {
    return str.replace(/,.*$/, "");
  };

  const toggleDropdown = () => {
    setIsDropdownOpened(!isDropdownOpened);
  };

  if (isLoading) {
    return (
      <div className="loading-screen" 
      style={{ 
        backgroundColor: 'rgba(255, 255, 255, 0.8)'}}>
                     <div><LoadingScreen/></div>
                   </div>
    );
  }


  return (
    <div className="root dashboard">
     
        <>
          
         
            <div className="d-flex align-items-center justify-content-between mb-3 px-3">
          <h4 className="mb-lg me-3">{t('Dashboard.Dashboard')}</h4>
         
        </div>
       <div>
       <Row className='mb-3' >
           
           <Col sm={12} md={3} className="rounded">
             <div className='card  h-100 p-3'>
               <div style={{ display: 'flex', alignItems: 'center', justifyContent: "space-between" }}>
                 <div>
               <h6 className="fw-semi-bold text-gray-600">{t('Dashboard.Remaining_Tasks')}</h6>
             <h2 className="mt-2">{dashboardData?.in_progress + dashboardData?.not_started}</h2>

             </div>
             <div className='bg-primary p-2 rounded'>
                 <FaExclamationCircle size={20} className="text-white" />
               </div>
               </div>
               </div>
           </Col>

         
           <Col sm={12} md={3} className="rounded">
             <div className='card  h-100 p-3'>
               <div style={{ display: 'flex', alignItems: 'center', justifyContent: "space-between" }}>
                 <div>
              
               <h6 className="fw-semi-bold text-gray-600">{t('Dashboard.Completed_Tasks')}</h6>
             <h2 className="mt-2">{dashboardData?.done}</h2>

             </div>
             <div className='bg-success p-2 rounded'>
             <FaCheckCircle size={20} className="text-white" />
             </div>
             </div>
             </div>
           </Col>

          
           <Col sm={12} md={3} className="rounded">
             <div className='card  h-100 p-3'>
               <div style={{ display: 'flex', alignItems: 'center', justifyContent: "space-between" }}>
                 <div>
                
               <h6 className="fw-semi-bold text-gray-600">{t('Dashboard.Tasks_in_progress')}</h6>
             <h2 className="mt-2">{dashboardData?.in_progress}</h2>

             </div>
             <div className='bg-warning p-2 rounded'>

             <RiProgress2Line size={20} className="text-white" />
             </div>
             </div>
             </div>
           </Col>
           

           <Col sm={12} md={3} className="rounded">
             <div className='card  h-100 p-3'>
               <div style={{ display: 'flex', alignItems: 'center', justifyContent: "space-between" }}>
                 <div>
                 <h6 className="fw-semi-bold text-gray-600">{t('Dashboard.Overdue_tasks')}</h6>

                 <h2 className="mt-2">{dashboardData?.overdue}</h2>
                 </div>

              
               <div className='bg-danger p-2 rounded'>
                   <FaExclamationTriangle size={20} className="text-white" />
                 </div>
               </div>
             
             </div>
           </Col>
         </Row>
<div className="assessment-card">
  <div className="card-header">
   
    <div className="card-actions">
      <button 
        onClick={() => navigate('/team-onboarding')}
        className="btn-primary"
      >
        Invite User
      </button>
      <button 
        onClick={() => navigate('/objective')}
        className="btn-outline"
      >
        View Objectives
      </button>
    </div>
  </div>
  
  <div className="card-content">
    <ResultAssessment />
  </div>
</div>
         <Row>
           <Col xs={12} md={4}>
             <Widget className="custom-widget">
               <h5 className="widget-title">
                 <span className="fw-semi-bold">{t('Dashboard.Reference/Compliance')}</span>
               </h5>
               <hr className="widget-separator" />
               <BarChart data={complianceForEachStandard} />
             </Widget>
           </Col>

           <Col xs={12} md={4}>
             <Widget className="custom-widget">
               <h5 className="widget-title">{t('Dashboard.Simple_Tasks')}</h5>
               <hr className="widget-separator" />
               <LineChart data={monthlyTasks} />
             </Widget>
           </Col>

           <Col xs={12} md={4}>
             <Widget className="custom-widget">
               <h5 className="widget-title">{t('Dashboard.Compliance_Status')}</h5>
               <hr className="widget-separator" />
               <PieChart data={complianceStatus} />
             </Widget>
           </Col>
         </Row>


         <Row className="mt-3">
           <Col xs={12}>
             <div className='bg-white p-3 rounded shadow-sm w-100'>
               <h5 className="mt-0 mb-3">
                 <i className="fa fa-user mr-xs opacity-70" /> {t('Dashboard.Users_Tasks')}
               </h5>
               <div className="table-responsive w-100">
                 <table className="styled-table rounded w-100">
                   <thead style={{backgroundColor:"#cccbca"}}>
                     <tr>
                       <th>{t('Dashboard.Name')}</th>
                       <th>{t('Dashboard.Username')}</th>
                       <th>{t('Dashboard.Email')}</th>
                       <th>{t('Dashboard.Not_Completed')}</th>
                     </tr>
                   </thead>
                   <tbody>
                     {usersTasksDashboard.map((user: any) => (
                       <tr key={user.id}>
                         <td>{user.name}</td>
                         <td>{user.username}</td>
                         <td>{user.email}</td>
                         <td>
                         <Badge color={user.inProgressTasks > 5 ? "danger" : user.inProgressTasks > 3 ? "warning" : "success"} className="ml-xs">
                           {user.inProgressTasks}
                         </Badge>
                       </td>
                     </tr>
                     ))}
                    
                    
                     
                     
                   </tbody>
                 </table>
               </div>
             </div>
           </Col>
         </Row>
       </div>

     
           

        </>
      
    </div>
  );
}

export default withTranslation()(Dashboard);
